import { useTranslation } from 'react-i18next';

import PageLayout from '~layouts/page/pageLayout';

import OrganisationsOverviewContainer from '../containers/organisationsOverviewContainer';

const OrganisationsPage = () => {
	const { t } = useTranslation();

	return (
		<PageLayout
			pageTitle={t('organisation.labels.plural', { ns: 'entities' })}
			crumbs={[]}
			headerInfo={{
				title: t('organisation.labels.plural', { ns: 'entities' }),
			}}
		>
			<OrganisationsOverviewContainer />
		</PageLayout>
	);
};

export default OrganisationsPage;
